import { useState, useEffect, useCallback } from 'react'
import { fmtFecha } from '../utils/fecha'
import { marketingApi } from '../api/marketing'
import Modal from '../components/Modal'
import Boton from '../components/Boton'

const ESTADO_CHIP = {
  suscripto:   { label: 'Suscripto',   bg: '#dcfce7', color: '#166534' },
  pendiente:   { label: 'Pendiente',   bg: '#fef9c3', color: '#a16207' },
  desuscripto: { label: 'Baja',        bg: '#f1f5f9', color: '#64748b' },
  bounce:      { label: 'Bounce',      bg: '#fee2e2', color: '#991b1b' },
}

export default function MktContactosPage() {
  const [data, setData] = useState(null)
  const [resumen, setResumen] = useState(null)
  const [q, setQ] = useState('')
  const [estado, setEstado] = useState('')
  const [page, setPage] = useState(1)
  const [modal, setModal] = useState(false)
  const [nuevo, setNuevo] = useState({ email: '', nombre: '', telefono: '', lista_id: '' })
  const [listas, setListas] = useState([])
  const [err, setErr] = useState('')

  const cargar = useCallback(async () => {
    const res = await marketingApi.contactos({ q: q || undefined, estado: estado || undefined, page })
    setData(res.data)
  }, [q, estado, page])

  useEffect(() => { cargar() }, [cargar])
  useEffect(() => {
    marketingApi.contactosResumen().then(r => setResumen(r.data))
    marketingApi.listas().then(r => setListas(r.data))
  }, [])

  const alta = async (e) => {
    e.preventDefault(); setErr('')
    try {
      await marketingApi.crearContacto({ ...nuevo, email: nuevo.email || undefined, telefono: nuevo.telefono || undefined, lista_id: nuevo.lista_id || undefined })
      setModal(false); setNuevo({ email: '', nombre: '', telefono: '', lista_id: '' }); cargar()
    } catch (error) { setErr(error.response?.data?.message || 'Error') }
  }

  const baja = async (c) => {
    if (!window.confirm(`¿Dar de baja a ${c.email}? Entra en la supresión global (no recibe más campañas).`)) return
    await marketingApi.bajaContacto(c.id); cargar()
  }

  const rows = data?.data || []

  return (
    <div>
      <div style={st.head}>
        <h2 style={st.title}>Contactos</h2>
        <Boton variante="primary" onClick={() => setModal(true)}>+ Agregar contacto</Boton>
      </div>

      {resumen && (
        <div style={st.kpis}>
          {[
            ['Total', resumen.total],
            ['Suscriptos', resumen.por_estado?.suscripto || 0],
            ['Pendientes', resumen.por_estado?.pendiente || 0],
            ['Bajas', resumen.por_estado?.desuscripto || 0],
            ['Suprimidos', resumen.suprimidos],
          ].map(([l, v]) => (
            <div key={l} style={st.kpi}><p style={st.kpiV}>{v}</p><p style={st.kpiL}>{l}</p></div>
          ))}
        </div>
      )}

      <div style={st.filtros}>
        <input style={st.buscador} placeholder="Buscar email o nombre…" value={q} onChange={e => { setQ(e.target.value); setPage(1) }} />
        <select style={st.select} value={estado} onChange={e => { setEstado(e.target.value); setPage(1) }}>
          <option value="">Todos</option>
          {Object.entries(ESTADO_CHIP).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      <div style={st.tableWrap}>
        <table style={st.table}>
          <thead><tr>{['Email', 'Nombre', 'Teléfono', 'Estado', 'Origen', 'Últ. compra', ''].map(h => <th key={h} style={st.th}>{h}</th>)}</tr></thead>
          <tbody>
            {rows.map(c => {
              const chip = ESTADO_CHIP[c.estado] || ESTADO_CHIP.pendiente
              return (
                <tr key={c.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={st.td}>{c.email || '—'}</td>
                  <td style={st.td}>{c.nombre || c.cliente?.nombre || '—'}</td>
                  <td style={st.td}>{c.telefono
                    ? <a href={`https://wa.me/${c.telefono.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" style={{ color: '#15803d', textDecoration: 'none' }}>📱 {c.telefono}</a>
                    : '—'}</td>
                  <td style={st.td}><span style={{ ...st.chip, background: chip.bg, color: chip.color }}>{chip.label}</span></td>
                  <td style={st.td}>{c.origen}</td>
                  <td style={st.td}>{c.ultima_compra_at ? fmtFecha(c.ultima_compra_at) : '—'}</td>
                  <td style={st.td}>
                    {c.estado !== 'desuscripto' && (
                      <Boton variante="destructive" sm onClick={() => baja(c)}>Dar de baja</Boton>
                    )}
                  </td>
                </tr>
              )
            })}
            {rows.length === 0 && (
              <tr><td colSpan={7} style={{ ...st.td, textAlign: 'center', color: '#94a3b8', padding: 28 }}>
                Sin contactos. Importá tu audiencia de Mailchimp (<code>marketing:importar-mailchimp</code>) o sincronizá desde clientes.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {data && data.last_page > 1 && (
        <div style={st.pager}>
          <button style={st.pagerBtn} disabled={page <= 1} onClick={() => setPage(p => p - 1)}>‹</button>
          <span style={{ color: '#64748b', fontSize: '0.85rem' }}>{data.current_page} / {data.last_page} · {data.total} contactos</span>
          <button style={st.pagerBtn} disabled={page >= data.last_page} onClick={() => setPage(p => p + 1)}>›</button>
        </div>
      )}

      {modal && (
        <Modal title="Agregar contacto" onClose={() => setModal(false)}>
          <form onSubmit={alta} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={st.lbl}>Email</label>
              <input style={st.inp} type="email" value={nuevo.email} onChange={e => setNuevo(n => ({ ...n, email: e.target.value }))} autoFocus />
            </div>
            <div>
              <label style={st.lbl}>Teléfono (WhatsApp)</label>
              <input style={st.inp} value={nuevo.telefono} onChange={e => setNuevo(n => ({ ...n, telefono: e.target.value }))} placeholder="ej: 11 5555 5555" />
              <p style={{ fontSize: '0.75rem', color: '#94a3b8', margin: '4px 0 0' }}>Cargá al menos uno de los dos. Los leads de VG suelen dejar teléfono — las promos por email arrancan solo si hay email.</p>
            </div>
            <div>
              <label style={st.lbl}>Nombre</label>
              <input style={st.inp} value={nuevo.nombre} onChange={e => setNuevo(n => ({ ...n, nombre: e.target.value }))} />
            </div>
            <div>
              <label style={st.lbl}>Agregar a lista (opcional)</label>
              <select style={st.inp} value={nuevo.lista_id} onChange={e => setNuevo(n => ({ ...n, lista_id: e.target.value }))}>
                <option value="">Ninguna</option>
                {listas.filter(l => l.tipo === 'estatica').map(l => <option key={l.id} value={l.id}>{l.nombre}</option>)}
              </select>
              <p style={{ fontSize: '0.75rem', color: '#94a3b8', margin: '4px 0 0' }}>Si la lista dispara una automation, el contacto entra solo a la secuencia (ej: lead de Instagram → persecución con promos).</p>
            </div>
            <p style={{ fontSize: '0.78rem', color: '#94a3b8', margin: 0 }}>El alta manual implica consentimiento explícito → queda suscripto.</p>
            {err && <p style={{ color: '#dc2626', fontSize: '0.875rem', margin: 0 }}>{err}</p>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Boton variante="ghost" type="button" onClick={() => setModal(false)}>Cancelar</Boton>
              <Boton variante="primary" type="submit">Agregar</Boton>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}

const st = {
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 },
  title: { margin: 0, fontSize: '1.4rem', color: '#0f172a' },
  kpis: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 10, marginBottom: 14 },
  kpi: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '12px 14px', textAlign: 'center' },
  kpiV: { margin: 0, fontSize: '1.25rem', fontWeight: 800, color: '#0f172a' },
  kpiL: { margin: '2px 0 0', fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase' },
  filtros: { display: 'flex', gap: 10, marginBottom: 12 },
  buscador: { flex: 1, maxWidth: 360, padding: '0.55rem 0.8rem', border: '1px solid #d1d5db', borderRadius: 8 },
  select: { padding: '0.55rem 0.8rem', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff' },
  tableWrap: { background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '10px 14px', fontSize: '0.72rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' },
  td: { padding: '10px 14px', fontSize: '0.88rem', color: '#1e293b' },
  chip: { padding: '3px 10px', borderRadius: 10, fontSize: '0.74rem', fontWeight: 700 },
  pager: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 14, marginTop: 14 },
  pagerBtn: { padding: '0.4rem 0.9rem', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer' },
  lbl: { display: 'block', fontWeight: 600, fontSize: '0.85rem', color: '#374151', marginBottom: 4 },
  inp: { width: '100%', padding: '0.55rem 0.75rem', border: '1px solid #d1d5db', borderRadius: 8, boxSizing: 'border-box' },
}
